import ProgressGoalSettingOutcomeGoals from 'dashboard/templates/views/Patient/Progress/ProgressGoalSettingOutcomeGoals';

export default {
    path: 'outcome-goals',
    name: 'ProgressGoalSettingOutcomeGoals',
    component: ProgressGoalSettingOutcomeGoals,
    meta: {
        // title: 'Patient Record - Progress - Goal Setting - Outcome Goal',
        // title: t => `${t('patient.patientRecord')} - ${t('journeyProgress.progress')} - ${t('journeyProgress.goalSetting')} - ${t('dummy.outcomeGoals.outcomeGoal')}`,
        // title: 'Journey - Progress - Goal Setting',
        title: t => `${t('buttons.journey', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
        loggedInOnly: true,
        inSDMSessionOnly: true
    }
};
